import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { postComment } from '@behavior/activity/api';
import { ActionCommentDTO } from '@behavior/activity/dto/ActionCommentDTO';
import { QueryKey } from '@behavior/QueryKey';

const KNOWN_BACKEND_KEYS = new Set([
  'message.error.add.comment.empty',
  'message.error.add.comment.action.not.found',
  'message.error.add.comment.unauthorized',
  'message.error.add.comment.failed',
]);

function backendKeyToToastKey(backendKey: string): string {
  return backendKey.replace('message.error.', 'message.title.error.');
}

function usePostComment(actionId: number) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation(
    (comment: ActionCommentDTO) => postComment(actionId, comment),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryKey.ACTION, actionId]);
        toast.success(t('message.title.success.add.comment'));
      },
      onError: (error: unknown) => {
        const axiosError = error as AxiosError<string>;
        const body = axiosError?.response?.data;
        if (typeof body === 'string' && KNOWN_BACKEND_KEYS.has(body)) {
          toast.error(t(backendKeyToToastKey(body)));
          return;
        }
        toast.error(t('message.title.error.add.comment.failed'));
      },
    }
  );
  return mutateAsync;
}

export default usePostComment;
